// Table headings for allocation tables
export const allocationTableHeadings = [
  { name: "Storage Date", id: "storage_date"},
  { name: "Biofuel Type", id: "biofuel_type" },
  { name: "Origin", id: "raw_material_origin" },
  { name: "Biocomponent Type", id: "fuel_type" },
  { name: "Raw Material", id: "raw_material" },
  { name: "Advanced", id: "double_counted_norway" },
  { name: "Ghg Reduction", id: "reduction_in_climate_emission" },
  { name: "Storage Terminal", id: "storage_terminal" },
  {
    name: "Available Quantity (L)",
    alignRight: true,
    id: "available_quantity",
  },
  {
    name: "Allocated Quantity (L)",
    alignRight: true,
    id: "allocated_quantity",
  },
];

export const allocationSurplusTableHeadings = [
  { name: "Bio mandate", id: "bio_mandate"},
  { name: "Biofuel Type", id: "biofuel_type" },
  { name: "Biocomponent Type", id: "fuel_type" },
  {
    name: "Available Surplus (L)",
    alignRight: true,
    id: "available_quantity",
  },
  {
    name: "Allocated Surplus (L)",
    alignRight: true,
    id: "allocated_quantity",
  },
];

// Previous table headings for allocation tables
export const allocationPrevTableHeadings = [
  { name: "Biofuel Type", id: "biofuel_type" },
  { name: "Origin", id: "origin" },
  { name: "Biocomponent Type", id: "biocomponent_type" },
  { name: "Raw Material", id: "raw_material" },
  { name: "Advanced", id: "advanced" },
  { name: "Ghg Reduction", id: "ghg_reduction" },
  { name: "Storage Terminal", id: "storage_terminal" },
  {
    name: "Available Quantity (L)",
    alignRight: true,
    id: "available_quantity",
  },
  {
    name: "Allocated Quantity (L)",
    alignRight: true,
    id: "allocated_quantity",
  },
];

// Types for table heading objects
export interface TableHeading {
  name: string;
  id: string;
  alignRight?: boolean;
}
